module.exports = __webpack_public_path__ + "static/media/casting.29633179.png";